import React from 'react'
import { Translation } from '@morningtrain/react-translations'
import * as Displays from 'support/displays'
import WhenModelValue from 'support/conditionals/WhenModelValue'

export default function FiredAtBadge () {
  return (
          <WhenModelValue name="inactive_at">
            <div className="fieldset simple form-field full-width">
              <div className="inline-flex items-baseline px-2.5 py-0.5 rounded-full text-sm font-medium bg-red-100 text-red-800 md:mt-2 lg:mt-0">
                <Translation name="hr.users.partials.fired_from"/> <Displays.Date name="inactive_at"/>
              </div>
            </div>
          </WhenModelValue>
  )
}
